// Variables
var imgGallery;
var imgGaleries;
var galleryImages = [];
var i = 0;
var modalImg;
var windowWidth = window.innerWidth;
var modalClose = document.querySelector('.modal__close');
var faTimes = document.querySelector('.fa-times');
var modalBox = modalClose ? modalClose : faTimes;
var modalOverlay = document.querySelector('.modal__overlay');
var mobileClose = document.querySelector('.mobile__close');
var modalImg = document.querySelector('.modal-img');
var modalImageList = document.querySelector('#modal__image-list');

function loop() {
  requestAnimationFrame(function () {
    // Loop until gallery has loaded
    if (document.querySelector('.img--gallery') === null) {
      loop();
    } else {
      imgGaleries = document.querySelectorAll('.img--gallery');

      for (var j = 0; j < imgGaleries.length; j++) {
        var imgGalleryChildrens = [].slice.call(imgGaleries[j].children);

        // Change the source of imagei n the modal when you click image
        imgGalleryChildrens.map(function (elem) {
          console.log(elem);
          elem.addEventListener('click', function (event) {
            var imgGallery = event.target.parentNode.parentNode.parentNode;
            galleryImages = [];
            imgGallery.querySelectorAll('img').forEach(function (elem) {
              galleryImages.push(elem.src);
            });
            if (windowWidth >= 880) {
              i = galleryImages.indexOf(event.target.src);
              modalBox.addEventListener('click', function () {
                modalImg.src = '';
              });
              modalOverlay.addEventListener('click', function () {
                modalImg.src = '';
              });
              showImg();
            } else {
              modalImageList.innerHTML = '';
              preLoadImage();
            }
          });
        });
      }
    }
  });
}
loop();

function preLoadImage() {
  galleryImages.forEach((img) => {
    var liElement = document.createElement('LI');
    liElement.classList.add('gallery-slide');
    liElement.classList.add('image-gallery--slide');
    var imgSrc = document.createElement('IMG');
    imgSrc.src = `${img}`;
    liElement.appendChild(imgSrc);
    modalImageList.appendChild(liElement);
    modalImageList.style.overflow = 'auto';
  });
}

function nextImg() {
  if (i < galleryImages.length - 1) {
    i++;
  } else {
    i = 0;
  }
  showImg();
}

// Set src of the iamge
function showImg() {
  modalImg.src = galleryImages[i];
}

// Go to previous image inside the modal
function prevImg() {
  i--;
  if (i < 0) {
    i = galleryImages.length - 1;
  }
  showImg();
}
